import { SelectorOption } from './components/RawSelector';

export const TITLES: SelectorOption[] = [
  {
    value: 'athletic_director',
    displayName: 'Athletic Director',
    selected: true,
  },
  { value: 'coach', displayName: 'Coach' },
  { value: 'director', displayName: 'Director' },
  { value: 'financial_administrator', displayName: 'Financial Administrator' },
  { value: 'teacher', displayName: 'Teacher' },
  { value: 'team_manager', displayName: 'Team Manager' },
  { value: 'controller', displayName: 'Controller' },
  { value: 'vp', displayName: 'VP' },
  { value: 'avp', displayName: 'AVP' },
  { value: 'treasurer', displayName: 'Treasurer' },
  { value: 'secretary', displayName: 'Secretary' },
  { value: 'bookkeeper', displayName: 'Bookkeeper' },
  { value: 'ceo', displayName: 'CEO' },
  { value: 'cfo', displayName: 'CFO' },
  { value: 'coo', displayName: 'COO' },
  { value: 'cio', displayName: 'CIO' },
  { value: 'president', displayName: 'President' },
  { value: 'benefits', displayName: 'Benefits' },
  { value: 'executive', displayName: 'Executive' },
  { value: 'chairman', displayName: 'Chairman' },
  { value: 'manager', displayName: 'Manager' },
  { value: 'partner', displayName: 'Partner' },
  { value: 'member', displayName: 'Member' },
];

export const STATES: SelectorOption[] = [
  { value: 'AL', displayName: 'Alabama', selected: true },
  { value: 'AK', displayName: 'Alaska' },
  { value: 'AZ', displayName: 'Arizona' },
  { value: 'AR', displayName: 'Arkansas' },
  { value: 'CA', displayName: 'California' },
  { value: 'CO', displayName: 'Colorado' },
  { value: 'CT', displayName: 'Connecticut' },
  { value: 'DE', displayName: 'Delaware' },
  { value: 'FL', displayName: 'Florida' },
  { value: 'GA', displayName: 'Georgia' },
  { value: 'HI', displayName: 'Hawaii' },
  { value: 'ID', displayName: 'Idaho' },
  { value: 'IL', displayName: 'Illinois' },
  { value: 'IN', displayName: 'Indiana' },
  { value: 'IA', displayName: 'Iowa' },
  { value: 'KS', displayName: 'Kansas' },
  { value: 'KY', displayName: 'Kentucky' },
  { value: 'LA', displayName: 'Louisiana' },
  { value: 'ME', displayName: 'Maine' },
  { value: 'MD', displayName: 'Maryland' },
  { value: 'MA', displayName: 'Massachusetts' },
  { value: 'MI', displayName: 'Michigan' },
  { value: 'MN', displayName: 'Minnesota' },
  { value: 'MS', displayName: 'Mississippi' },
  { value: 'MO', displayName: 'Missouri' },
  { value: 'MT', displayName: 'Montana' },
  { value: 'NE', displayName: 'Nebraska' },
  { value: 'NV', displayName: 'Nevada' },
  { value: 'NH', displayName: 'New Hampshire' },
  { value: 'NJ', displayName: 'New Jersey' },
  { value: 'NM', displayName: 'New Mexico' },
  { value: 'NY', displayName: 'New York' },
  { value: 'NC', displayName: 'North Carolina' },
  { value: 'ND', displayName: 'North Dakota' },
  { value: 'OH', displayName: 'Ohio' },
  { value: 'OK', displayName: 'Oklahoma' },
  { value: 'OR', displayName: 'Oregon' },
  { value: 'PA', displayName: 'Pennsylvania' },
  { value: 'RI', displayName: 'Rhode Island' },
  { value: 'SC', displayName: 'South Carolina' },
  { value: 'SD', displayName: 'South Dakota' },
  { value: 'TN', displayName: 'Tennessee' },
  { value: 'TX', displayName: 'Texas' },
  { value: 'UT', displayName: 'Utah' },
  { value: 'VT', displayName: 'Vermont' },
  { value: 'VA', displayName: 'Virginia' },
  { value: 'WA', displayName: 'Washington' },
  { value: 'WV', displayName: 'West Virginia' },
  { value: 'WI', displayName: 'Wisconsin' },
  { value: 'WY', displayName: 'Wyoming' },
];

export const BUSINESS_STRUCTURES_THAT_REQUIRE_OWNERS = [
  'multi_member_llc',
  'private_partnership',
  'unincorporated_association',
  'sole_proprietorship',
  'single_member_llc',
];

export const SPLIT_KEY = '@snap-mobile/vault';
export const AWAIT_PROP_TIMEOUT_SECONDS = 30;

export const DEFAULT_OWNERSHIP_VALUE = 25;

export const SUPPORTED_FILE_FORMATS = [
  'image/png',
  'image/jpeg',
  'application/pdf',
];
